import { render, staticRenderFns } from "./Func3CartaoVirtual.vue?vue&type=template&id=5f867f1e&scoped=true"
import script from "./Func3CartaoVirtual.vue?vue&type=script&lang=js"
export * from "./Func3CartaoVirtual.vue?vue&type=script&lang=js"
import style0 from "./Func3CartaoVirtual.vue?vue&type=style&index=0&id=5f867f1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f867f1e",
  null
  
)

export default component.exports